import useToastes from "./useToastes";

export default function useHandleCopy(isToastDisabled?: boolean) {
  const { successToast } = useToastes()
  return (text: string) => navigator.clipboard.writeText(text).then(() => {
    if (isToastDisabled) return;
    successToast("Successfully copied");
  });
};
